import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  FaArrowLeft,
  FaArrowRight,
  FaImage,
} from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import { RiShareForwardLine } from "react-icons/ri";

const ImagesViewDialog = ({ open, onClose, images = [], onDownload }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleShare = () => {
    alert("Share functionality not implemented yet!");
  };

  const handleNextImage = () => {
    if (!images || images.length === 0) return;
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevImage = () => {
    if (!images || images.length === 0) return;
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          width: "900px",
          maxWidth: "900px",
          borderRadius: "8px",
          overflow: "visible",
          fontFamily: "'Inter', sans-serif",
        },
      }}
      sx={{
        "& *": { fontFamily: "'Inter', sans-serif !important" },
      }}
    >
      <IconButton
        style={{ position: "absolute", top: 8, right: 8, color: "#838383" }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle style={{ padding: "16px", borderBottom: "1px solid #eee" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: "16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaImage style={{ color: "#1E4DE3", fontSize: "20px" }} />
             
          </div>
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              gap: "8px",
              marginRight: "48px",
            }}
          >
 
            <Button
              variant="outlined"
              startIcon={<MdOutlineFileDownload style={{ color: "#1E4DE3" }} />}
              onClick={onDownload}
              sx={{
                borderColor: "#d3d3d3",
                color: "#1E4DE3",
                textTransform: "none",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  borderColor: "#1E4DE3",
                  boxShadow: "0 2px 8px rgba(30, 77, 227, 0.2)",
                  backgroundColor: "#e8f0fe",
                },
              }}
            >
              Download
            </Button>
            <Button
              variant="text"
              startIcon={<RiShareForwardLine style={{ color: "#000" }} />}
              onClick={handleShare}
              style={{
                backgroundColor: "#d3d3d3",
                color: "#000",
                textTransform: "none",
                boxShadow: "none",
              }}
            >
              Share
            </Button>
          </div>
        </div>
      </DialogTitle>

      <DialogContent style={{ padding: "16px" }}>
        <div
          style={{
            position: "relative",
            width: "100%",
            // paddingTop: "56.25%", // 16:9 ratio
            // backgroundColor: "#000",
            // marginBottom: "16px",
            aspectRatio: "16 / 9",  
            backgroundColor: "#000",
             marginBottom: "16px",
            overflow: "hidden", 
          }}
        >
          {images && images.length > 0 ? (
            <>
              <img
                src={images[currentImageIndex]}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  position: "absolute",
                //   top: 0,
                //   left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                // objectFit: "cover",
                }}
              />
              <IconButton
                onClick={handlePrevImage}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "20px",
                  transform: "translateY(-50%)",
                  backgroundColor: "#444",
                  color: "#fff",
                }}
              >
                <FaArrowLeft />
              </IconButton>
              <IconButton
                onClick={handleNextImage}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "20px",
                  transform: "translateY(-50%)",
                  backgroundColor: "#444",
                  color: "#fff",
                }}
              >
                <FaArrowRight />
              </IconButton>
              <div
              style={{
                position: "absolute",
                bottom: "10px",
                right: "20px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "#fff",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {currentImageIndex + 1} / {images.length}
            </div>
            </>
          ) : (
            <p
              style={{
                color: "#fff",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              No images available
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
ImagesViewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.string),
  onDownload: PropTypes.func,
};

export default ImagesViewDialog;
 
